import React from 'react';
import { Button } from 'react-bootstrap';
import { BsPlus } from 'react-icons/bs';
import { connect, useDispatch } from 'react-redux';

import * as _ from 'lodash';
import { setCategory, setToast } from '../../../../containers/client/actions';
import { saveState } from '../../../../lib/storages';
import { translate } from 'react-i18next';
import { makeGetCategory, makeGetToken } from '../../../../lib/selector';
import RenderFieldInput from '../../../input/renderFieldInput';
import { maxLength, required } from '../../../../utils/validation';
import { Field, reduxForm } from 'redux-form';
import { v4 as uuidv4 } from 'uuid';
import {uniqBy} from 'lodash'

const maxLength20 = maxLength(20);

function ItemAddWatchList(props) {
  const dispatch = useDispatch();

  const { handleSubmit, pristine, submitting, t } = props;

  const submit = (value) => {
    const { categoryName } = value;
    const { category, reset } = props;

    const countWatchList = _.filter(category, (o) => o.type === 'watchlist');
    if (countWatchList && countWatchList.length >= 15) {
        const toastMsg = {
          id: Math.random(),
          msg: t('txt-valid-5-catalog'),
          title: t('txt-notice'),
        };
        setToast(toastMsg);
        return;
      }

      if (
        _.some(category, (o) => o.type === 'watchlist' && o.name === categoryName)
      ) {
        const toastMsg = {
          id: Math.random(),
          msg: t('txt-valid-exist-category') + categoryName,
          title: t('txt-notice'),
        };
        setToast(toastMsg);
        return;
      }
      const uuid = uuidv4();
      // add category
      const catalog = {
        id: uuid,
        name: categoryName,
        path: '/home/bang-gia/' + uuid,
        pinnedRow: [],
        value: [],
        type: 'watchlist',
      };
  
      const _newCategory = uniqBy([...category, catalog], 'path');;
      console.log(_newCategory);
      
      dispatch(setCategory(_newCategory));
      saveState('category', _newCategory);
      reset();

    return;
  };

  return (
    <div
      className='d-flex nav-item-drop'
    >
        <form onSubmit={handleSubmit(submit)} className="d-flex">
          <Field
            name="categoryName"
            type="text"
            id="categoryName"
            className="field-change-catalog"
            placeholder={t('txt-portfolio')}
            component={RenderFieldInput}
            validate={[required, maxLength20]}
          />
          <Button
            variant="secondary"
            type="submit"
            disabled={pristine || submitting}
            className="mr-1 ml-1 btn-drop"
            style={{marginTop: '3px'}}
          >
            <BsPlus className="text-white" />
          </Button>
        </form>
    </div>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getCategory = makeGetCategory();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      category: getCategory(state),
    };
  };
  return mapStateToProps;
};

const connected = connect(makeMapStateToProps)(ItemAddWatchList);

const formed = reduxForm({
  form: 'addCatalog',
})(connected);

export default translate('translations')(formed);
